/** @format */

import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { FormikProps } from "formik";
import * as React from "react";
import { useAppSelector } from "../../app/hooks";
import { selectConstants } from "./Api/constantSlice";
import { DropdownDto } from "./Api/Models";
import { ErrorBox } from "../custom/ErrorBox";

interface Props {
  formik: FormikProps<any>;
}
export default function DocumentTypes({ formik }: Props) {
  const selConst = useAppSelector(selectConstants);

  return (
    <>
      {selConst.constantState.documentTypes && (
        <>
          <FormControl fullWidth>
            <InputLabel
              error={
                formik.touched.documentTypeId &&
                Boolean(formik.errors.documentTypeId)
              }
              id="demo-select-small"
            >
              Document Type
            </InputLabel>
            <Select
              required
              name="documentTypeId"
              labelId="demo-select-small"
              id="demo-select-small"
              value={formik.values.documentTypeId}
              label="Document Type"
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              error={
                formik.touched.documentTypeId &&
                Boolean(formik.errors.documentTypeId)
              }
            >
              <MenuItem value={-1} disabled>
                Document Type
              </MenuItem>
              {selConst.constantState.documentTypes.map(
                (data: DropdownDto, key: number) => {
                  return (
                    <MenuItem key={key} value={data.id}>
                      {data.description}
                    </MenuItem>
                  );
                }
              )}
            </Select>
          </FormControl>

   <ErrorBox>
   {formik.touched.documentTypeId &&
              (formik.errors.documentTypeId as React.ReactNode)}
                              </ErrorBox>


        </>
      )}
    </>
  );
}
